"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculateNextPage = (currentPage, resultsPerPage, totalResults) => {
    if (!resultsPerPage || !totalResults)
        return null;
    if ((currentPage + 1) * resultsPerPage >= totalResults) {
        return null;
    }
    return currentPage + 1;
};
exports.default = calculateNextPage;
//# sourceMappingURL=calculateNextPage.js.map